import { useState } from 'react';
import { AuthProvider, useAuth } from './context/AuthContext';
import Login from './screens/Login';
import Home from './screens/Home';
import Chat from './screens/Chat';
import Messenger from './screens/Messenger';
import Social from './screens/Social';
import Finance from './screens/Finance';
import Tools from './screens/Tools';
import Games from './screens/Games';
import Email from './screens/Email';
import Profile from './screens/Profile';
import Settings from './screens/Settings';
import AdminPanel from './screens/AdminPanel';
import { BottomNav } from './components/BottomNav';
import { Header } from './components/Header';
import './App.css';

function AppInner() {
  const { user, loading } = useAuth();
  const [screen, setScreen] = useState('home');

  if (loading) {
    return (
      <div className="min-h-screen bg-[#08080c] flex items-center justify-center">
        <div 
          className="font-mono text-lg tracking-wider"
          style={{ 
            color: '#00d4ff',
            textShadow: '0 0 20px rgba(0, 212, 255, 0.5)'
          }}
        >
          SAGE
        </div>
      </div>
    );
  }

  if (!user) {
    return <Login />;
  }

  // Screens without custom headers
  const screensWithHeader = ['home', 'messenger', 'social', 'finance', 'tools', 'games', 'email'];
  const screenTitles = {
    home: null,
    messenger: 'Messenger',
    social: 'Feed',
    finance: 'Finance',
    tools: 'Tools',
    games: 'Games',
    email: 'Email'
  };

  const screens = {
    home: <Home navigate={setScreen} />,
    chat: <Chat navigate={setScreen} />,
    messenger: <Messenger navigate={setScreen} />,
    social: <Social navigate={setScreen} />,
    finance: <Finance navigate={setScreen} />,
    tools: <Tools navigate={setScreen} />,
    games: <Games navigate={setScreen} />,
    email: <Email navigate={setScreen} />,
    profile: <Profile navigate={setScreen} />,
    settings: <Settings navigate={setScreen} />,
    admin: <AdminPanel navigate={setScreen} />
  };

  const showHeader = screensWithHeader.includes(screen);

  return (
    <div className="max-w-md mx-auto relative min-h-screen bg-[#08080c]">
      {showHeader && <Header navigate={setScreen} title={screenTitles[screen]} />}
      {screens[screen] || screens.home}
      <BottomNav current={screen} navigate={setScreen} />
    </div>
  );
}

function App() {
  return (
    <AuthProvider>
      <AppInner />
    </AuthProvider>
  );
}

export default App;
